import React from 'react';
import close from "../../../images/close.svg";
import infoIcon from "../../../images/info-circle.svg";
import ReactTooltip from "react-tooltip";
import {Field, Formik} from "formik";
import infoYellow from '../../../images/info-yellow.svg'
import {CustomCheckBox} from "../../main/logbook/EditTable";
import TripsTable from "../TripsTable/TripsTable";
import {useTheme} from "../../../App";
import {connect} from "react-redux";
import {useTranslation} from "react-i18next";

const InviteMember = ({closeModal, trips}) => {
  const {isDark} = useTheme()
  const {t} = useTranslation()
  return (
    <div style={{width: '670px'}} className={`modal ${isDark && 'modal__dark'}`}>
      <button onClick={closeModal} className="modal__close">
        <img src={close} alt=""/>
      </button>
      <div className="modal__row">
        <h5 className="modal__title w-100 modal__row flex-end">
          {t('inviteMember')}
          <button data-tip data-for={'invite'} className="modal__infoButton">
            <img src={infoIcon} alt=""/>
          </button>
          {/*<ReactTooltip className={'tooltip'} backgroundColor={'#F7F8FB'} id={'info'} place="top" effect="solid">*/}
          {/*  */}
          {/*</ReactTooltip>*/}
        </h5>
      </div>
      <Formik
        initialValues={{
          email: '',
          isShareTrips: false,
          selectedCharters: []
        }}
        onSubmit={() => {
          closeModal()
        }}
      >
        {({values, handleSubmit, handleChange, setFieldValue}) => {
          return <>
            <div className="modal__sections">
              <div className="modal__section">
                <p className="modal__caption">{t('toAddTheDataEnterMail')}</p>
                <div className="modal__inputs mb-16 show-block">
                  <div className="modal__inputWrapper">
                    <Field className={'modal__input w-100 mt-16'} value={values.email} onChange={handleChange}
                           type={'email'} id={'email'}
                           placeholder={'Email'} maxLenght={50}/>
                    <div className="modal__notFound">
                      <img src={infoYellow} alt=""/>
                      {t('notFound')}
                    </div>
                    {values.email && <div className="modal__email">
                      {values.email}
                      <button onClick={() => setFieldValue('email', '')}>
                        <img src={close} alt=""/>
                      </button>
                    </div>}
                  </div>
                </div>
                <CustomCheckBox isDark={isDark}
                                marginBottom={'24px'} isChecked={values.isShareTrips} caption={t('shareTrip')}
                                fontFamily={'Lato500'}
                                color={'#454545'}
                                onClick={() => setFieldValue('isShareTrips', !values.isShareTrips)}/>
                {values.isShareTrips && <TripsTable isEdit={true} charters={trips} setFieldValue={setFieldValue}
                                                    selectedCharters={values.selectedCharters} isInvite={true} isDark={isDark}/>}
              </div>
            </div>
            <div className="modal__buttons">
              <div className="modal__actions">
                <button onClick={handleSubmit} className="submit-button">
                  {t('invite')}
                </button>
                <button onClick={closeModal} className="commonBtn">
                  <span className="commonBtn__label">{t('cancel')}</span>
                </button>
              </div>
            </div>
          </>
        }}
      </Formik>
    </div>
  );
};

const mapStateToProps = (state) => ({
  trips: state.logbookReducer.trips
})

export default connect(mapStateToProps, {})(React.memo(InviteMember));
